import { Typography } from '@/components/primitives/Typography';
import { CarriageSelector } from '@/components/purchase/checkout/seat-selection/modal/CarriageSelector';
import { FloorSelector } from '@/components/purchase/checkout/seat-selection/modal/FloorSelector';
import { LegSelectionBanner } from '@/components/purchase/checkout/seat-selection/modal/LegSelectionBanner';
import { SeatMapKey } from '@/components/purchase/checkout/seat-selection/modal/SeatMapKey';
import { VehicleLayoutContainer } from '@/components/purchase/checkout/seat-selection/modal/VehicleLayoutContainer';
import { salesPointConfigurationSelector } from '@/features/configuration/configurationSelector';
import { useSeatSelection } from '@/hooks/useSeatSelection';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';

const SeatSelectionContent = () => {
  const salesPointConfiguration = useSelector(salesPointConfigurationSelector);
  const currency = salesPointConfiguration?.currencies?.[0];
  const { currentPlaceMap, floorPlanIcons } = useSeatSelection();
  const floors = currentPlaceMap?.floors ?? [];
  const hasFloors = floors.length > 1;

  return (
    <div className="flex flex-col gap-2 pb-4">
      <LegSelectionBanner />
      <div className="flex w-full items-center justify-between px-4">
        <SeatMapKey floorPlanIcons={floorPlanIcons} />
        <Typography variant="body2" className="text-neutral">
          <TransText
            i18nKey="pricesDisplayedInCurrency"
            values={{ currency }}
          />
        </Typography>
      </div>
      <CarriageSelector />
      {hasFloors && <FloorSelector />}
      <VehicleLayoutContainer />
    </div>
  );
};

export default SeatSelectionContent;
